define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'readingiq-src/js/riq-js/tag-model-service/1.0.0/index-impl',
  'readingiq-src/js/riq-js/riq-api-service/1.0.0/index'
  /* eslint-enable */
], function service(app, tagModelServiceImpl) {
  'use strict';

  app.registerService('tagModelService', [
    'riqApiService',
    '$q',
    tagModelServiceImpl
  ]);
});
